// extracted by mini-css-extract-plugin
export default {"primaryColor":"#0f141a","secondaryColor":"#ffa902","secondaryColorLighten":"rgb(255,203.6719367589,104)","textColor":"#15104d"};